import React from 'react';
import ServicesEditTemplate from './services-edit-template'

const ExpressEntryService = () => {
    return <ServicesEditTemplate doc="express_entry" service="Express Entry" />;
};

export default ExpressEntryService;
